import * as React from "react";
import { Box } from "@talentpair/quantic";
import "./BgTypingIndicator.css";

export function BgTypingIndicator(): React.ReactElement {
  return (
    <Box
      data-testid="assistantTypingIndicator"
      variant="row"
      layout="center-start"
      className="typing-indicator"
    >
      <div>&nbsp;</div>
      <div>&nbsp;</div>
      <div>&nbsp;</div>
    </Box>
  );
}
